import React, { useEffect, useState, useCallback } from "react";
import { useContent } from "contexts/contentContext/contentContext.js";
import Icon from "components/Elements/Icon/Icon.tsx";
import FormBuilderHeader from "../FormBuilderHeader.js";
import FormBuilderFooterAndButton from "../FormBuilderFooterAndButton.js";
import { useToasts } from "react-toast-notifications";
import FormBuilderListElements from "./FormBuilderListElements.js";
import makeAllBoolInObjectFalse from "../../../Helpers/makeAllBoolInObjectFalse.ts";
import generateCopiedFieldLabel from "../../../Helpers/generateCopiedFieldLabel.ts";

const FormBuilderContainer = ({
  formJson,
  setFormJson,
  fieldToAdd,
  setFieldToAdd,
  detailsMode,
  showImage,
  formImage,
  showTitle,
  formDescription,
  showDescription,
  formDisplayTitle,
  setDetailsMode,
  linkFooters,
  formButtonsColor,
  formButtonTextColor,
  displayFooterLinks,
  selectFieldToEdit,
  formItems,
  setFormItems,
  continueText,
  activeField,
  setActiveField,
  setUpdateBeforeSave,
  directionForm,
  setFieldSelected,
  formLanguage,
  formBackgroundColor,
  formWidth,
  setFormHeight,
  newHeightCalculated,
  formInnerScroll,
}) => {
  const { getTextByKey } = useContent();
  const [emptyHeader, setEmptyHeader] = useState(false);
  const [removeOrAddField, setRemoveOrAddField] = useState(false);

  const { addToast } = useToasts();
  const [firstLoad, setFirstLoad] = useState(true);

  const [heightForDisplay, setHeightForDisplay] = useState(
    newHeightCalculated + 30
  );
  const [maxHegihtInputs, setMaxHegihtInputs] = useState(450);
  useEffect(() => {
    if (newHeightCalculated) {
      const hideDetails = !showImage && !showTitle && !showDescription;
      const headerHeight = hideDetails ? 88 : 156;
      const buttonHeight = 102;
      const footerHeight = 40;
      const heightOfFooterAndHeader =
        headerHeight + buttonHeight + footerHeight;
      const maxHeightInputsTemp = newHeightCalculated - heightOfFooterAndHeader;
      setMaxHegihtInputs(maxHeightInputsTemp);
      //add 30 to the height to make sure the scroll is working
      const newHeightCalculatedTemp = parseInt(newHeightCalculated) + 30;
      setHeightForDisplay(newHeightCalculatedTemp);
    }
  }, [newHeightCalculated, showImage, showTitle, showDescription]);

  useEffect(() => {
    if (formJson && formJson.items && firstLoad) {
      let tempItems = formJson.items.map((item) => {
        return {
          ...item,
          id: generateId(),
        };
      });
      setFormItems(tempItems);
      setFirstLoad(false);
    }
  }, [formJson]);

  useEffect(() => {
    if (fieldToAdd) {
      // Check if trying to add recipientDropdown when it already exists
      if (
        fieldToAdd.template === "recipientDropdown" &&
        formItems.some((item) => item.template === "recipientDropdown")
      ) {
        addToast(getTextByKey("recipient-field-exists"), {
          appearance: "error",
        });
        setFieldToAdd(null);
        return;
      }

      let newFieldToAdd = { ...fieldToAdd };
      newFieldToAdd.fields.label = getTextByKey(fieldToAdd.fields.label);
      if (newFieldToAdd.template === "multiplecheckboxes") {
        let tempCheckboxes = newFieldToAdd.fields.checkboxes;
        let newCheckboxes = [];
        tempCheckboxes.forEach((element) => {
          newCheckboxes.push(getTextByKey(element));
        });
        newFieldToAdd.fields.checkboxes = newCheckboxes;
      } else if (newFieldToAdd.template === "multipleradios") {
        let tempCheckboxes = newFieldToAdd.fields.radios;
        let newCheckboxes = [];
        tempCheckboxes.forEach((element) => {
          newCheckboxes.push(getTextByKey(element));
        });
        newFieldToAdd.fields.radios = newCheckboxes;
      } else if (newFieldToAdd.template === "selectbasic") {
        let tempCheckboxes = newFieldToAdd.fields.options;
        let newCheckboxes = [];
        tempCheckboxes.forEach((element) => {
          newCheckboxes.push(getTextByKey(element));
        });
        newFieldToAdd.fields.options = newCheckboxes;
      }
      newFieldToAdd.id = generateId();
      setFormItems([...formItems, newFieldToAdd]);
      setRemoveOrAddField(true);
      setFieldToAdd(null);
      setActiveField(newFieldToAdd.id);
      selectFieldToEdit(newFieldToAdd);
    }
  }, [fieldToAdd]);

  const generateId = () => {
    return (
      Math.random().toString(36).substring(2, 15) +
      Math.random().toString(36).substring(2, 15)
    );
  };

  useEffect(() => {
    let displayImage = true;
    let displayTitle = true;
    let displayDescription = true;
    if (!formImage || !showImage) {
      displayImage = false;
    }

    if (!formDisplayTitle || !showTitle) {
      displayTitle = false;
    }

    if (!formDescription || !showDescription) {
      displayDescription = false;
    }

    if (!displayDescription && !displayTitle && !displayImage) {
      setEmptyHeader(true);
    } else {
      setEmptyHeader(false);
    }
  }, [
    formImage,
    showImage,
    showTitle,
    formDisplayTitle,
    formDescription,
    showDescription,
  ]);

  const openTitleAndDescription = () => {
    setDetailsMode("form-details");
  };

  const actionsContainer = (item) => {
    const copyActionIsHidden = item.template === "recipientDropdown";

    return (
      <div className="field-actions">
        {/* <div
          onClick={(e) => editFunction(e, item)}
          type="edit"
          className="edit-button action"
          title="Edit"
        >
          <Icon name="pencil-alt-solid" />
        </div> */}
        {!copyActionIsHidden && (
          <div
            onClick={(e) => copyFunction(e, item)}
            type="copy"
            className="copy-button action"
            title="Copy"
          >
            <Icon name="copy-field" />
          </div>
        )}
        <div
          onClick={(e) => removeFunction(e, item)}
          type="remove"
          className="del-button action"
          title="Remove"
        >
          <Icon name="trash-solid-b" />
        </div>
      </div>
    );
  };

  const checkIfExistEmailField = (fields) => {
    let existEmailField = false;
    fields.forEach((item) => {
      if (item.template === "emailinput") {
        existEmailField = true;
      }
    });
    return existEmailField;
  };

  const removeFunction = (e, field) => {
    e.stopPropagation();
    let tempItems = formItems.filter((item) => item.id !== field.id);
    let allowToDelete = true;
    if (tempItems.length <= 0) {
      allowToDelete = false;
      addToast(getTextByKey("minimum-one-field"), {
        appearance: "error",
      });
    }
    if (field.template === "emailinput") {
      let existEmailField = checkIfExistEmailField(tempItems);
      if (!existEmailField) {
        allowToDelete = false;
        addToast(getTextByKey("minimum-one-email"), {
          appearance: "error",
        });
      }
    }
    if (allowToDelete) {
      if (activeField === field.id) {
        setActiveField(null);
        setFieldSelected(null);
        setDetailsMode("form-details");
      }
      setFormItems(tempItems);
      setRemoveOrAddField(true);
    }
  };

  const copyFunction = (e, field) => {
    e.stopPropagation();

    let tempItems = [];
    //add newCloneField to list after field
    formItems.forEach((item) => {
      if (item.id === field.id) {
        tempItems.push(field);
        //create copy of field
        let newCloneField = { ...field };

        // Set all toggles to tuned off
        const fieldsWithAllBooleanSetToFalse = makeAllBoolInObjectFalse(
          field.fields
        );
        newCloneField.fields = fieldsWithAllBooleanSetToFalse;

        // Generates a unique label for the copied field
        newCloneField.fields.label = generateCopiedFieldLabel(
          getTextByKey,
          item.fields.label,
          formItems
        );

        //generate new id for field
        newCloneField.id = generateId();
        if (newCloneField.fields.downloadname) {
          if (countDownloadName() >= 3) {
            addToast(getTextByKey("max-limit-zip"), {
              appearance: "error",
            });
            //change to false only to new field
            newCloneField.fields.downloadname = false;
          }
        }

        if (newCloneField.fields.includeinemailsubject) {
          if (countInlcudeInSubjectFields() >= 5) {
            addToast(getTextByKey("max-limit-subject"), {
              appearance: "error",
            });
            newCloneField.fields.includeinemailsubject = false;
          }
        }
        tempItems.push(newCloneField);
      } else {
        tempItems.push(item);
      }
    });

    setFormItems(tempItems);
    setRemoveOrAddField(true);
  };

  //count how many fields include prop downloadname
  const countDownloadName = () => {
    let count = 0;
    formItems.forEach((item) => {
      if (item.fields.downloadname) {
        count++;
      }
    });
    return count;
  };

  //count how many fields include prop includeinemailsubject
  const countInlcudeInSubjectFields = () => {
    let count = 0;
    formItems.forEach((item) => {
      if (item.fields.includeinemailsubject) {
        count++;
      }
    });
    return count;
  };

  const editFunction = (e, field) => {
    e.stopPropagation();
    setActiveField(field.id);
    selectFieldToEdit(field);
  };

  useEffect(() => {
    if (removeOrAddField) {
      let tempFormJson = { ...formJson };
      tempFormJson.items = formItems;
      setFormJson(tempFormJson);
      setUpdateBeforeSave({
        mode: true,
        action: "updateJson",
        heightChanged: true,
      });
      setRemoveOrAddField(false);
    }
  }, [removeOrAddField]);

  const findCard = useCallback(
    (id) => {
      const card = formItems.filter((c) => `${c.id}` === id)[0];
      return {
        card,
        index: formItems.indexOf(card),
      };
    },
    [formItems]
  );

  const moveCard = useCallback(
    (id, atIndex) => {
      const { card, index } = findCard(id);
      const newList = orderList(index, atIndex, formItems);
      setFormItems(newList);
      let tempFormJson = { ...formJson };
      tempFormJson.items = newList;
      setFormJson(tempFormJson);
      setUpdateBeforeSave({
        mode: true,
        action: "updateJson",
        heightChanged: true,
      });
    },
    [findCard, formItems, setFormItems]
  );

  const orderList = (sourceIndex, destIndex, list) => {
    let tempList = [...list];
    let sourceItem = tempList[sourceIndex];
    let destItem = tempList[destIndex];
    tempList.splice(sourceIndex, 1);
    tempList.splice(destIndex, 0, sourceItem);
    return tempList;
  };

  return (
    <div
      className={`form-builder-container ${
        directionForm === "rtl" ? "right-to-left" : "left-to-right"
      }`}
    >
      <div
        className="form-builder-content"
        style={{
          backgroundColor: formBackgroundColor,
          width: formWidth
            ? formWidth > 1000
              ? "1000px"
              : formWidth < 460
              ? "460px"
              : formWidth + "px"
            : "460px",
          height: formInnerScroll ? heightForDisplay : "auto",
        }}
      >
        <FormBuilderHeader
          detailsMode={detailsMode}
          showImage={showImage}
          formImage={formImage}
          showTitle={showTitle}
          formDescription={formDescription}
          showDescription={showDescription}
          formDisplayTitle={formDisplayTitle}
          emptyHeader={emptyHeader}
          openTitleAndDescription={openTitleAndDescription}
        />
        <FormBuilderListElements
          formItems={formItems}
          moveCard={moveCard}
          findCard={findCard}
          actionsContainer={actionsContainer}
          buttonsColor={formButtonsColor}
          editFunction={editFunction}
          activeField={activeField}
          maxHeightInputs={maxHegihtInputs}
          formInnerScroll={formInnerScroll}
          setFormItems={setFormItems}
        />
        <FormBuilderFooterAndButton
          detailsMode={detailsMode}
          formButtonsColor={formButtonsColor}
          setDetailsMode={setDetailsMode}
          formButtonTextColor={formButtonTextColor}
          continueText={continueText}
          displayFooterLinks={displayFooterLinks}
          linkFooters={linkFooters}
        />
      </div>
    </div>
  );
};

export default FormBuilderContainer;
